import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfigService} from '@shared-library';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-identity-verification-error',
  templateUrl: './identity-verification-error.component.html',
  styleUrl: './identity-verification-error.component.css',
  standalone: false
})
export class IdentityVerificationErrorComponent implements OnInit, OnDestroy {

  @Input() error = ""
  @Input() error_description = "An internal server error occurred. Please retry after a few moments."


  routeSubscription: Subscription;

  constructor(
    private configService: ConfigService,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.params.subscribe(val => {
      // this.configService.vaultProfileConfig = {
      //   identityVerificationFailureCount: (this.configService.vaultProfileConfig$.identityVerificationFailureCount || 0) + 1
      // }
      //
      // if((this.configService.vaultProfileConfig$.identityVerificationFailureCount || 0) >= 2){
      //   // if we fail to verify the patient's identity using Clear more than 2 times, we should just move onto the search experience instead.
      //   //make sure we set the mode to anonymous
      //   this.configService.systemConfig = {
      //     ...this.configService.systemConfig$,
      //     searchOnly: true
      //   }
      //   this.router.navigateByUrl("search")
      // }
    });
  }

  public ngOnDestroy(): void {
    // Prevent memory leaks
    if(this.routeSubscription){
      this.routeSubscription.unsubscribe();
    }
  }
}
